import gsap from 'gsap';
import { ScrollTrigger } from "gsap/all";

// Scroll Animation
gsap.registerPlugin(ScrollTrigger);

// Function to initialize animations
const initAnimations = () => {
    const animations = [
        { selector: '.ra-js-fade-up', props: { opacity: 0, y: 50 } },
        { selector: '.ra-js-fade-down', props: { opacity: 0, y: -50 } },
        { selector: '.ra-js-fade-left', props: { opacity: 0, x: -50 } },
        { selector: '.ra-js-fade-right', props: { opacity: 0, x: 50 } },
        { selector: '.px-js-fade-up', props: { opacity: 0, y: 50 } },
        { selector: '.px-js-fade-down', props: { opacity: 0, y: -50 } },
        { selector: '.px-js-fade-left', props: { opacity: 0, x: -50 } },
        { selector: '.px-js-fade-right', props: { opacity: 0, x: 50 } },
        { selector: '.fx-js-fade-up', props: { opacity: 0, y: 50 } },
        { selector: '.fx-js-fade-down', props: { opacity: 0, y: -50 } },
        { selector: '.fx-js-fade-left', props: { opacity: 0, x: -50 } },
        { selector: '.fx-js-fade-right', props: { opacity: 0, x: 50 } },
        { selector: '.ss-js-fade-up', props: { opacity: 0, y: 50 } },
        { selector: '.ss-js-fade-down', props: { opacity: 0, y: -50 } },
        { selector: '.ss-js-fade-left', props: { opacity: 0, x: -50 } },
        { selector: '.ss-js-fade-right', props: { opacity: 0, x: 50 } },
    ];

    // Loop through animations array and apply GSAP animations
    animations.forEach(({ selector, props }) => {
        // Select all elements matching the selector
        const elements = document.querySelectorAll(selector);

        // Check if elements exist to prevent errors
        if (elements.length > 0) {
            elements.forEach(elem => {
                gsap.from(elem, {
                    scrollTrigger: {
                        trigger: elem, // Element triggers the animation when in view
                        //start: 'top 75%', // Adjust scroll start location as needed
                    },
                    duration: 0.5,
                    ...props, // Spread the animation properties
                });
            });
        } else {
            // Uncomment this line if you want to log when no elements are found
             //console.warn(`No elements found for selector: ${selector}`);
        }
    });
};

// Set a timeout before running initAnimations
const animationTimeout = 100; // Timeout in milliseconds



export default function gsapAnimations() {
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(initAnimations, animationTimeout); // Delay the initialization
    });
}

gsapAnimations();